import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent implements OnInit {
  public disabled: boolean = false;
  public status: { isopen: boolean } = {isopen: false};
  public currentUser: any = {};
  public currentAdministration: any = {};
  public currentCommunity: any = {};

  constructor() {
  }

  public toggled(open: boolean): void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(): void {
    const currentUser = localStorage.getItem('currentUser');
    this.currentAdministration = localStorage.getItem('currentAdministration');
    this.currentCommunity = localStorage.getItem('currentCommunity');
    this.currentUser = JSON.parse(currentUser);
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts